<ion-header>
    <ion-toolbar class="ion-padding-end">
        <ion-title>{{Title}}</ion-title>

        <ion-button title="fechar" style="margin-right: -16px;" fill="clear" color="dark" shape="round" slot="end"
            (click)="OnCancel()">
            <ion-icon slot="icon-only" name="close-outline"></ion-icon>
        </ion-button>
    </ion-toolbar>
</ion-header>

<ion-content class="ion-padding" [scrollEvents]="true" (ionScroll)="OnScroll()">

    <div class="summary">

        <!-- aviso -->
        <ion-row class="alert-warning" *ngIf="Warning">
            <ion-icon name="warning-outline"></ion-icon>
            <p>{{Warning}}</p>
        </ion-row>

        <p class="message">{{Message}}</p>
        <p class="note" i18n=":@@modal_consumption_summary.note">Verifique atentamente os valores antes de
            prosseguir:</p>

        <!-- valores principais -->
        <div class="highlights">
            <div class="highlight" *ngFor="let item of Highlights">
                <span class="highlight-label">{{item.Label}}</span>
                <span class="highlight-value">{{item.Value || '--'}}</span>
            </div>
        </div>

        <!-- detalhes da operação -->
        <div class="details">
            <div class="detail" *ngFor="let item of Details">
                <ion-icon class="detail-icon" [name]="item?.Icon || 'ellipse-outline'"></ion-icon>
                <div class="detail-text">
                    <span class="detail-label">{{item?.Label}}</span>
                    <span class="detail-value">{{item?.Value || '--'}}</span>
                </div>
            </div>
        </div>

        <!-- no fim do conteúdo: fica no fundo do modal e, sem espaço, só se alcança com scroll -->
        <div class="summary-footer">
            <div class="footer-text">
                <p class="question">{{Question}}</p>
                <span class="scroll-hint" *ngIf="!HasScrolledToEnd"
                    i18n=":@@modal_consumption_summary.scroll-hint">Percorra todos os dados para poder confirmar.</span>
            </div>

            <div class="actions">
                <ion-button fill="outline" color="primary" (click)="OnCancel()"
                    i18n=":@@modal_consumption_summary.cancel">Cancelar</ion-button>
                <ion-button fill="solid" color="primary" [disabled]="!HasScrolledToEnd" (click)="OnConfirm()"
                    i18n=":@@modal_consumption_summary.confirm">Confirmar</ion-button>
            </div>
        </div>

    </div>

</ion-content>
